import { CrearScrapAlmacenLaser } from "@/utils/api_scrap_almacen_laser";

/**
 * Envía el reporte de Scrap de Almacen y Laser al back.
 * Recibe el payload de buildPayload() y devuelve el registro creado.
 * En caso de error de validación (400), relanza el error para que
 * el componente pueda mostrar los mensajes al usuario.
 *
 * @param {object} payload
 * @returns {{ id, fecha, hora, folio_generado_por_back, ... }}
 */

export const crearReporteScrapAlmacenLaser = async (payload) => {
  const data = await CrearScrapAlmacenLaser(payload);

  const year  = String(new Date().getFullYear()).slice(-2);
  const folio = `SAL-${year}-${String(data.id).padStart(4, "0")}`;

  return {
    folio,
    submittedAt: new Date().toISOString(),
  };
};
